import React from "react";
import styled from "@emotion/styled";

import Icon from "@/components/misc/Icon";

const StyledContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.5rem 1.25rem;
  border-radius: 10rem;
  color: #fff;
  background: #000;
  font-size: 0.9rem;
  letter-spacing: 0.05em;
`;

const SectionTitle: React.FC<{
  title: React.ReactNode;
  icon: string;
  className?: string;
  variant?: "light" | "dark";
}> = ({ title, icon, className, variant = "dark" }) => {
  return (
    <StyledContainer
      className={className}
      style={
        variant === "light"
          ? {
              color: "var(--clr-primary-100, #5f57ff)",
              background: "#fff",
            }
          : {}
      }
    >
      <Icon
        isSrcRelative
        src={icon}
        size="xxs"
        colorVariant={variant === "light" ? "primary" : "white"}
      />
      <span>{title}</span>
    </StyledContainer>
  );
};

export default SectionTitle;
